import { Services } from "appworks/services/services";
import { RandomRangeInt } from "appworks/utils/math/random";
import { TGRFakeSymbolValueComponent } from "components/tgr-fake-symbol-value";

export class DMFFakeSymbolValueComponent extends TGRFakeSymbolValueComponent {

    public getRealQHSymbolId(showingamount: number): string {
        const multiplier: number = showingamount / Services.bet.getTotalStake();
        if (this.valueMap.has(multiplier)) {
            return `QHj${this.valueMap.get(multiplier)}`;
        } else {
            return `QH_${multiplier}`;
        }
    }

    public getFakeQHSymbolId(): string {
        const multiplier = this.levels[RandomRangeInt(0, this.nMax - 1)];
        if (this.valueMap.has(multiplier)) {
            return `QHj${this.valueMap.get(multiplier)}`;
        } else {
            return `QH_${multiplier}`;
        }
    }
}
